export default __webpack_public_path__ + "static/media/Plus-Outline.dced7bac.svg";